import { columnsStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

styles.leftColumnGridItem = {
    ...styles.leftColumnGridItem,
    css: css`
        ${styles.leftColumnGridItem?.css}

        & [data-widget="ProductList/ProductListFiltersAccordion"] {
            & [data-test-selector="sectionHeader"] {
                &:first-child {
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }
                &:last-child {
                    border-bottom-left-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
        }
    `,
};
